import styled from 'styled-components';
import { BeeInput } from './components/BeeInput/BeeInput';

export const StyledBeeTextInput = styled(BeeInput)`
  height: 3.5rem;
`;
